import { InputItem, List, WhiteSpace, Button, Toast } from "antd-mobile-v2";
import React from "react";
import { createForm } from "rc-form";
import "./index.less";
import allUrl from "../../../api/allUrl";
import { post, get, postRaw } from "../../../api/service/services";
import tool from "../../../api/tool";
import md5 from "js-md5";
import sectioValue from "../../../api/service/secsstion";
import "../../../assets/iconfont/iconfont.css";
import "../../../assets/iconfont/demo.css";
import { sm4 } from "sm-crypto";
import publicKey from "../../../constants/publicKey";

React.Component.prototype.$md5 = md5;
const tabs = [{ title: "账号登录" }, { title: "短信登录" }];
const Item = List.Item;
class UserLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 60,
            flagCode: true,
            imageKey: {}
        };
    }
    componentDidMount () {
        // console.log(111, sm4.decrypt("a380c774a601c1bac30fa158070e63b0",publicKey))
        this.getImageCode();
    }
    validateAccount = (rule, value, callback) => {
        if (value && value.length > 4) {
            callback();
        } else {
            callback(new Error("At least four characters for account"));
        }
    };
    // 获取图片验证码
    getImageCode = () => {
        get(allUrl.register.getImageCode, {})
            .then((res) => {
                if (res.success === true && res.code == 200) {
                    let imgKey = res.data.key || "";
                    let imageUrl = res.data.image || "";
                    this.setState({
                        imageKey: {
                            imageKey: imgKey,
                            imageUrl: imageUrl,
                        },
                    });
                } else {
                    Toast.info(res.data.msg, 1);
                }
            })
            .catch((err) => {
                Toast.info("验证码获取失败，请重试", 1);
            });
    };
    // 数据提交
    onSubmit = () => {
        this.props.form.validateFields((error, values) => {
            if (error) {
                let errorData = Object.keys(error)[0];
                Toast.info(error[errorData].errors[0].message, 1);
                return;
            }
            values["grant_type"] = "password";
            values["password"] = sm4.encrypt(values.password, publicKey)
            values["scope"] = "all";
            this.submitData(values);
            console.log(values, "登录准备提交的数据");
        });
    };
    submitData = (data) => {
        const { getFieldValue } = this.props.form;
        let imageCode = getFieldValue("imageCode");
        postRaw(allUrl.register.userAllLogin, data, {
            "Content-Type": "application/x-www-form-urlencoded",
            "Captcha-Code": imageCode,
            "Captcha-Key": this.state.imageKey.imageKey,
            Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
        })
            .then((res) => {
                if (res && res.access_token && res.token_type && res.account) {
                    let num = new Date().getTime() + (1000 * 60 * 15 - 4000);
                    sectioValue.set("tokenTime", num);
                    sectioValue.set("refstoken", `${res.refresh_token}`);
                    sectioValue.set("token", `${res.token_type}   ${res.access_token}`);
                    sectioValue.set("acount", res.account);
                    sectioValue.set("user_id", res.user_id);
                    sectioValue.set("nick_name", res.nick_name);
                    this.props.props.history.push("/home");
                } else {
                    Toast.info("用户信息获取失败", 1, () => {
                        this.getImageCode();
                    });
                }
            })
            .catch((error) => {
                if (error.data && error.data.msg) {
                    Toast.info(error.data.msg, 1, () => {
                        this.getImageCode();
                    });
                } else {
                    Toast.info("登录失败", 1, () => {
                        this.getImageCode();
                    });
                }
            });
    };

    // 获取验证码
    isPhone = () => {
        const { flagCode } = this.state;
        let phoneS = this.props.form.getFieldValue("phoneNumber");
        if (!phoneS) {
            Toast.fail("请输入手机号", 1);
            return;
        }
        if (!flagCode) {
            return;
        }
        get(allUrl.register.getIsPhoneCode, { phone: phoneS })
            .then((res) => {
                if (res.success === true && res.code == 200) {
                    this.countDown();
                } else {
                    Toast.info(res.msg, 1);
                }
            })
            .catch((error) => {
                Toast.info("验证码获取失败", 1);
            });
    };
    // 倒计时
    countDown = () => {
        const { count, flagCode } = this.state;
        let timer = null;
        let num = count;
        this.setState({
            flagCode: false,
        });
        timer = setInterval(() => {
            if (num <= 1) {
                clearInterval(timer);
                num = 60;
                this.setState({
                    flagCode: true,
                });
            }
            num--;
            this.setState({
                count: num,
            });
        }, 1000);
    };
    render () {
        const { getFieldProps, getFieldError } = this.props.form;
        const { flagCode, count } = this.state;
        return (
            <div className="user-login-wrap">
                <form>
                    <InputItem
                        {...getFieldProps("userName", {
                            rules: [{ required: true, message: "请输入姓名" }],
                        })}
                        placeholder="请输入姓名"
                        maxLength={30}
                    >
                        <span
                            className="iconfont icon-yonghu"
                            style={{ color: "#BABABA" }}
                        ></span>
                    </InputItem>
                    <InputItem
                        {...getFieldProps("idNumber", {
                            rules: [
                                { required: true, message: "请输入证件号码" },
                                {
                                    required: false,
                                    pattern: new RegExp(
                                        /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                                        "g"
                                    ),
                                    message: "请输入正确的身份证",
                                },
                            ],
                        })}
                        placeholder="请输入证件号码"
                    >
                        <span
                            className="iconfont icon-zhengjianhaoma"
                            style={{ color: "#BABABA" }}
                        ></span>
                    </InputItem>
                    <WhiteSpace />
                    <InputItem
                        {...getFieldProps("password", {
                            rules: [
                                { required: true, message: "请输入密码" },
                                {
                                    required: false,
                                    pattern: new RegExp(
                                        /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
                                        "g"
                                    ),
                                    message: "请输入正确的密码",
                                },
                            ],
                        })}
                        placeholder="请输入密码"
                        type="password"
                        maxLength={50}
                    >
                        <span
                            className="iconfont icon-suo"
                            style={{ color: "#BABABA" }}
                        ></span>
                    </InputItem>
                    <div style={{ position: "relative" }}>
                        <InputItem
                            {...getFieldProps("imageCode")}
                            placeholder="请输入图片验证码"
                            type=""
                            maxLength={50}
                        >
                            <span></span>
                        </InputItem>
                        <div
                            className="code-image"
                            onClick={() => {
                                this.getImageCode();
                            }}
                        >
                            <img src={this.state.imageKey.imageUrl || ""}></img>
                        </div>
                    </div>
                    <InputItem
                        {...getFieldProps("phoneNumber", {
                            rules: [
                                { required: true, message: "请输入手机号" },
                                {
                                    required: false,
                                    pattern: new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/, "g"),
                                    message: "请输入正确的手机号",
                                },
                            ],
                        })}
                        placeholder="请输入手机号"
                        type=""
                        labelNumber={3}
                        maxLength={50}
                    >
                        <div>+86</div>
                    </InputItem>
                    <div style={{ position: "relative" }}>
                        <InputItem
                            {...getFieldProps("smsCaptcha", {
                                rules: [
                                    { required: true, message: "请输入验证码" }
                                ],
                            })}
                            placeholder="请输入验证码"
                            type=""
                            labelNumber={3}
                            maxLength={6}
                        >
                            <div>验证码</div>
                        </InputItem>
                        <div
                            className="code"
                            onClick={() => {
                                this.isPhone();
                            }}
                            style={{
                                color: flagCode ? "#337fd3" : "#ccc",
                                borderColor: flagCode ? "#337fd3" : "#ccc",
                            }}
                        >
                            {flagCode ? "获取验证码" : `${count}S重新获取`}
                        </div>
                    </div>
                    <WhiteSpace />
                    <WhiteSpace />
                    <WhiteSpace />
                    <div
                        style={{
                            position: "absolute",
                            left: "0",
                            bottom: "0",
                            width: "100%",
                            padding: "0 0.1rem",
                        }}
                    >
                        <Button type="primary" onClick={this.onSubmit}>
                            登录
                        </Button>
                    </div>
                </form>
            </div>
        );
    }
}

export default createForm()(UserLogin);
